import React, { useContext, useMemo, useState } from 'react';
import { TSelectedDetail } from '../../../../../../../../Types/MasterDetailTypes';
import { useBusinessDataFormContext } from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { IFormData } from '../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { ObjektVyKort } from '../../../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import { bokforderModel } from '../../../Utils/detaljvyUtils';
import BokforderContext from '../../BokforderContext/BokforderContext';
import { BokforderEditKonteringSwitch } from '../../BokforderEditKonteringSwitch/BokforderEditKonteringSwitch';
import { UtanordningGridView } from '../UtanordningGrid';
import EDButton from '../../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIconButton from '../../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDIcon from '../../../../../../../../BaseComponents/Icon/EDIcon';
import { useIsSmallBreakpoint } from '../../../../../../../../Components/BreakpointContext/BreakpointContextUtils';
import { EK_USE_IMPORT_FROM_CLIPBOARD } from '../../../../../Rutiner/Bokforder/Const/BokforderSysoptionConsts';
import { EKBokforderSysoptionQuery_db_SYSOptions_All } from '../../../../../Rutiner/Bokforder/Queries/_QueryTypes/EKBokforderSysoptionQuery';
import { BokforderWrapperContext } from '../../../../../Rutiner/Bokforder/Contexts/BokforderWrapperContext';

interface IProps {
  id: TSelectedDetail;
}

export const UtanordningGridCard: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const formContext = useBusinessDataFormContext();
  const bokforderWrapperContext = useContext(BokforderWrapperContext);
  const bokforderContext = useContext(BokforderContext);
  const bokforderContextSetImportDialogOpen =
    bokforderContext.setImportDialogOpen;
  const isEditMode = bokforderContext.isEditMode;
  const isSmall = useIsSmallBreakpoint();
  const [editKontering, setEditKontering] = useState(false);

  const ekUseImportFromClipboard: boolean = useMemo(() => {
    return (
      bokforderWrapperContext.sysOptions?.find(
        (option: EKBokforderSysoptionQuery_db_SYSOptions_All) =>
          option?.OptionKey === EK_USE_IMPORT_FROM_CLIPBOARD
      )?.OptionData === 'Y'
    );
  }, [bokforderWrapperContext.sysOptions]);

  const hasMadeChangesToKontering: boolean = useMemo(() => {
    if (formContext?.formState?.values?._Associations != undefined) {
      for (const assocValue of Object.values(
        formContext?.formState?.values?._Associations
      )) {
        if (assocValue && Array.isArray(assocValue)) {
          const rows = assocValue as IFormData;
          const result = rows?.some((row: any) => {
            if (row._Associations) {
              for (const [innerAssocKey, innerAssocValue] of Object.entries(
                row._Associations
              )) {
                if (innerAssocKey.includes('Kontodel')) {
                  const innerCastedValue = innerAssocValue as any;

                  if (innerCastedValue != undefined) {
                    return true;
                  }
                }
              }
            }
            return false;
          });

          if (result == true) {
            return result;
          }
        }
      }
    }
    return false;
  }, [formContext?.formState?.values]);

  return (
    <ObjektVyKort
      noPadding
      bmod={bokforderModel}
      caption="Kontering"
      hideHeaderMenu
      button={() => (
        <>
          {ekUseImportFromClipboard &&
            (isEditMode || editKontering) &&
            (isSmall ? (
              <EDIconButton
                color="secondary"
                icon="importFromFile"
                margin="dense"
                onClick={() => bokforderContextSetImportDialogOpen(true)}
                padding="dense"
                tooltip="Importera från Urklipp"
              />
            ) : (
              <EDButton
                label="Importera från Urklipp"
                onClick={() => bokforderContextSetImportDialogOpen(true)}
                flat
                icon={
                  <EDIcon iconType="importFromFile" mr={1} color="primary" />
                }
              />
            ))}

          <>
            {bokforderContext.showAttestantKonteraSwitch && (
              <BokforderEditKonteringSwitch
                editKontering={editKontering}
                hasMadeChangesToKontering={hasMadeChangesToKontering}
                setEditKontering={setEditKontering}
              />
            )}
          </>
        </>
      )}
    >
      <UtanordningGridView
        editKontering={editKontering}
        id={props.id}
        setEditKontering={setEditKontering}
      />
    </ObjektVyKort>
  );
};
